import { APP_PREFIX_PATH } from "../configs/AppConfig";


export const getAuthenticatedEntry = (user) => {
  if (!user) {
    return `${APP_PREFIX_PATH}/brand-store`;
  }

  if (hasBrandStoreAccess(user)) {
    return `${APP_PREFIX_PATH}/brand-store`;
  }

  if (hasWardrobeAccess(user)) {
    return `${APP_PREFIX_PATH}/dashboard`;
  }

  return `${APP_PREFIX_PATH}/brand-store`;
};


export const getFallbackPath = (user) => {
  return getAuthenticatedEntry(user);
};

export const hasBrandStoreAccess = (user) => {
  if (!user) return true;
  if (user.is_sunday_super_admin) return true;
  if (user.current_company?.has_brand_store_access === false) return false;
  return user.has_brand_store_access !== false;
};

export const hasWardrobeAccess = (user) => {
  if (!user) return true;
  if (user.is_sunday_super_admin) return true;
  if (user.current_company?.has_wardrobe_access === false) return false;
  return user.has_wardrobe_access !== false;
};

export const hasRoleAccess = (user, requiredRoles, allowClosetAdmin = false) => {
  if (!requiredRoles || requiredRoles.length === 0) return true;
  if (!user) return false;
  if (user.is_sunday_super_admin) return true;
  const userRoles = user.role?.map((r) => r.name) || [];
  if (allowClosetAdmin && user.is_closet_admin && userRoles.includes("STAFF")) return true;
  return requiredRoles.some((role) => userRoles.includes(role));
};

export const hasCatalogAccess = (user) => {
  if (!user) return true;
  if (user.is_sunday_super_admin) return true;
  if (user.current_company?.has_catalog_access === false) return false;
  return user.has_catalog_access !== false;
};

// Company swag store — a locked teaser/placeholder in the app menu. Access is
// OFF for everyone until BE explicitly sets `has_company_swag_store_access`
// (on the user or current_company). No super-admin bypass on purpose: while it
// is a placeholder with no route, the item must stay locked (opens the pitch
// modal) for everyone — including Sunday admins.
export const hasSwagStoreAccess = (user) =>
  user?.has_company_swag_store_access === true ||
  user?.current_company?.has_company_swag_store_access === true;

// Request Forms (internal request / IR) — limited rollout: the nav section is
// visible only for Sunday (company 1) and Cloudflare (company 30).
const REQUEST_FORMS_COMPANY_IDS = [1, 30];

export const hasRequestFormsAccess = (user) => {
  const companyId = user?.current_company_id ?? user?.current_company?.id;
  return REQUEST_FORMS_COMPANY_IDS.includes(Number(companyId));
};

// Campaign burner links — internal tooling, visible only while the acting company
// is Sunday itself. Keyed on the company name rather than is_sunday_super_admin on
// purpose: that flag persists across a company switch, and this page must follow the
// company the user is currently acting as, matching the `is_sunday_company` gate the
// API enforces.
export const isSundayCompany = (user) => user?.current_company?.name === "Sunday";

// Agency access — true if user is on agency company OR belongs to agency (persists across switch).
// Per BE: is_agency flips with current_company; is_from_agency stays true for users that belong
// to an agency, even after switching to a managed child company.
export const hasAgencyAccess = (user) =>
  Boolean(user?.is_agency || user?.is_from_agency);

// Commission visibility — when BE returns hide_commission=true, every commission/rebate
// figure (table columns, cards, charts, drawers) must be hidden across /agency/*.
// The flag exists on the user root and nested on current_company.
export const isCommissionHidden = (user) => {
  const flag = user?.hide_commission ?? user?.current_company?.hide_commission;
  return flag === true;
};
